import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import InputField from "./InputField";

export default function SearchInput() {
  return (
    <InputField
      fieldsetBorderColor="rgba(224, 224, 224, 1)"
      style={{
        background: "#f9fbfd",
        borderRadius: "20px",
        boxShadow:
          "rgb(204 209 232 / 37%) 3px 3px 6px 0px inset, rgb(255 255 255 / 50%) -3px -3px 6px 1px inset",
      }}
      startAdornment={<SearchIcon color="primary" />}
      placeholder="Sök..."
    />
  );
}
